<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :rules="rules" class="demo-ruleForm">
      <el-form-item label="ICCID列表：" prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          :placeholder="'以回车键分割ICCID\n最多200条数据'"
          rows="6"
          style="width:420px;font-size:14px"
        ></el-input>
      </el-form-item>
      <el-form-item label="执行模式：" prop="expire" label-width="151px" >
        <el-radio-group v-model="ruleForm.autoRecovery" >
          <el-radio label="1">月初自动恢复</el-radio>
          <el-radio label="2">月初不自动恢复</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="限速值：" prop="speedLabel" label-width="151px" >
        <el-select v-model="ruleForm.speedLabel" placeholder="限速值" clearable >
          <el-option
              v-for="item in speedLimitRateList"
              :key="item.value"
              :label="item.label"
              :value="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="submitForm('ruleForm')" >提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {speedCard} from "@/api/api.js"; //卡分配的提交
export default {
  name:"speed",
  data() {
    return {
      ruleForm: {
        autoRecovery: "1",
        speedLabel: "",
      },
      speedLimitRateList: [
        {label:"不限制",value:0},
        {label:"1Kbps",value:1},
        {label:"512Kbps",value:2},
        {label:"1Mbps",value:3},
        {label:"3Mbps",value:4},
        {label:"5Mbps",value:5},
        {label:"10Mbps",value:6},
      ],
      submitLoading:false,
      rules: {
        autoRecovery: [
          { required: true, message: "执行模式不能为空", trigger: "blur" },
        ],
        speedLabel: [
          { required: true, message: "限速值不能为空", trigger: "blur" },
        ],
      }
    };
  },
  watch:{
    $route: {
      handler(){
        this.$set(this.ruleForm,"iccids",this.$route.params.iccids);
      },
      immediate:true
    }
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    submitForm() {
      let { iccids } = this.ruleForm;
      let params = {
        ...this.ruleForm,
        iccids:iccids ? iccids.split("\n") : []
      };
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          speedCard(params).then(res => {
            this.$notify.info({
              title: "提示",
              message: "已提交卡限速，请在任务中心查看进度",
              duration: 1000,
              offset:30
            });
            setTimeout(()=>{
              this.ruleForm ={};
              this.$router.push({ path: `/taskCenter/missionList`});
            },1000)
          })
        }
      });
    },
  },
  created() {
  },
  mounted() {
  }
};
</script>
<style scoped>

</style>
